fragment AppearanceFragment on ChatSettings {
    lookAndFeel {
        color
        secondaryColor
        chatVariant
        nameDisplay
        chatbotName
        chatbotIconEnum
        nudgeSettings {
            isEnabled
            message
            callToAction
            deviceVisibility
        }
        icon {
            type
            url
        }
        conversationStarter
        showPoweredBy
        disclaimerSettings {
            isEnabled
            message
        }
        actionBarShownActions
        actionBarHiddenActions
        disabledPaths
    }
}
